import CheckListSection from './CheckListSection.js';
import './InfoBar.scss';
import checks from '../checkConfig.js';
import Score from './Score.js';
import SettingsButton from './SettingsButton.js';
import TfIdf from './TfIdf.js';
import LocalStorage from '../lib/LocalStorage.js';

const InfoBar = function(props) {
	const filterChecks = function(sectionName) {
		const sectionChecks = checks.filter((check) => check.section === sectionName);
		return sectionChecks;
	};

	const content = {
		content: props.content,
		keyword: LocalStorage.getItem('content-focus-keyword'),
		siteUrl: LocalStorage.getItem('content-page-url'),
	};

	return (
		<div className="info-bar">
			<div className="check-list-settings">
				<SettingsButton clickHandler={props.toggleSettingsCallback} />
			</div>
			<Score score={props.score} />
			<div className="check-list-section">
				<h3 className="check-list-section-title">{window?.t?.INFO_AND_STATS}</h3>
				<CheckListSection
					content={content}
					checks={filterChecks('info')}
					isPro={props.isPro}
					appSettings={props.appSettings}
					noIcon={true}
				/>
			</div>
			<div className="check-list-section tf-idf">
				<h3 className="check-list-section-title">{window?.t?.TOP10_WORDS}</h3>
				<TfIdf
					text={content.content}
					isPro={props.isPro}
					appSettings={props.appSettings}
					toggleSettingsCallback={props.toggleSettingsCallback}
				/>
			</div>
		</div>
	);
}

export default InfoBar;